import React from "react";
import styled, { css } from "styled-components";
import { Flex } from "./Flex";
import { SVGCheckmark, SVGError, SVGCancel } from "./SVGCollection";
import { hexToRGBA, bp } from "@styles/theme";

interface AlertStripProps {
    type: "success" | "warning" | "error";
    label: string | React.ReactNode;
    className?: string;
    withMargin?: boolean;
}

export const AlertStrip = (props: AlertStripProps) => {
    return (
        <AlertStripContainer type={props.type} className={props.className} withMargin={props.withMargin}>
            <AlertStripFlexContainer>
                <IconWrapper aria-hidden={true}>
                    {props.type === "success" && <SVGCheckmark />}
                    {props.type === "warning" && <SVGError />}
                    {props.type === "error" && <SVGCancel />}
                </IconWrapper>
                <AlertStripText>{props.label}</AlertStripText>
            </AlertStripFlexContainer>
        </AlertStripContainer>
    );
};

const AlertStripContainer = styled.div<{ type: "success" | "warning" | "error"; withMargin: boolean | undefined }>`
    width: 100%;
    ${props => props.type === "success" && `background-color: ${hexToRGBA(props.theme.color.green, 0.15)}`};
    ${props => props.type === "warning" && `background-color: ${hexToRGBA(props.theme.color.yellowL, 0.5)}`};
    ${props => props.type === "error" && `background-color: ${hexToRGBA(props.theme.color.red, 0.1)}`};

    ${props =>
        props.withMargin &&
        css`
            margin-bottom: 20px;
        `}
`;

export const AlertStripFlexContainer = styled(Flex.Container).attrs({
    $justifyContent: "center",
    $alignItems: "center",
})`
    min-height: 40px;
    padding: 0 20px;
`;

const IconWrapper = styled.div`
    margin-right: 14px;

    ${bp.medium} {
        margin-right: 24px;
    }
`;

const AlertStripText = styled.span`
    font-size: 12px;
    line-height: 18px;
    font-weight: 700;

    ${bp.medium} {
        font-size: 14px;
        line-height: 21px;
    }

    ${bp.large} {
        font-size: 18px;
        line-height: 27px;
    }
`;
